import { ChangeDetectionStrategy, Component, input } from '@angular/core'
import { SearchTournamentItem } from '@/features/search/search.model'

@Component({
	selector: 'tournament-panel-card',
	templateUrl: './tournament-panel-card.component.html',
	styleUrl: './panel-card.css',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class TournamentPanelCardComponent {
	readonly item = input.required<SearchTournamentItem>()
}
